import React from "react";
import { Link, NavLink } from "react-router-dom";
// import useAuth from "../hooks/useAuth";

const AdminNav = () => {
  // const { auth } = useAuth();

  const toggleSubMenu = (e) =>
    e.target.parentNode
      .querySelector(".mininav-content")
      .classList.toggle("collapse");
  return (
    <>
      <div className="mainnav__categoriy py-3">
        <h6 className="mainnav__caption mt-0 px-3 fw-bold">Navigation</h6>
        <ul className="mainnav__menu nav flex-column">
          {/* <!-- Link with submenu --> */}
          <li className="nav-item">
            <NavLink
              to="/dashboard"
              className={({ isActive }) =>
                isActive ? "nav-link active" : " nav-link"
              }
            >
              <i className="demo-pli-home fs-5 me-2"></i>
              <span className="nav-label ms-1">Dashboard</span>
            </NavLink>
          </li>
          {/* <!-- END : Link with submenu --> */}

          {/* <!-- Link with submenu --> */}
          <li className="nav-item">
            <NavLink
              to="/desktop"
              className={({ isActive }) =>
                isActive ? "nav-link active" : " nav-link"
              }
            >
              <i className="demo-pli-split-vertical-2 fs-5 me-2"></i>
              <span className="nav-label ms-1">Desktop</span>
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink
              to="/approvals"
              className={({ isActive }) =>
                isActive ? "nav-link active" : " nav-link"
              }
            >
              <i className="demo-pli-tactic fs-5 me-2"></i>
              <span className="nav-label ms-1">My Approvals</span>
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink
              to="/reports"
              className={({ isActive }) =>
                isActive ? "nav-link active" : " nav-link"
              }
            >
              <i className="demo-pli-file fs-5 me-2"></i>
              <span className="nav-label ms-1">Reports</span>
            </NavLink>
          </li>
          {/* <!-- END : Link with submenu --> */}
        </ul>
      </div>
      {/* <!-- END : Navigation Category --> */}

      <div className="mainnav__categoriy py-3">
        <h6 className="mainnav__caption mt-0 px-3 fw-bold">App</h6>
        <ul className="mainnav__menu nav flex-column">
          {/* <!-- Link with submenu --> */}
          <li className="nav-item has-sub">
            <NavLink
              to="/clients"
              className={({ isActive }) =>
                isActive
                  ? "mininav-toggle nav-link active"
                  : "mininav-toggle nav-link collapsed"
              }
              onClick={toggleSubMenu}
            >
              <i className="demo-pli-boot-2 fs-5 me-2"></i>
              <span className="nav-label ms-1">Clients</span>
            </NavLink>
            <ul className="mininav-content nav collapse">
              <li className="nav-item">
                <NavLink to="/clients/add" className="nav-link">
                  Add New
                </NavLink>
              </li>
            </ul>
          </li>

          <li className="nav-item">
            <NavLink
              to="/policies"
              className={({ isActive }) =>
                isActive
                  ? "mininav-toggle nav-link active"
                  : "mininav-toggle nav-link collapsed"
              }
              // onClick={toggleSubMenu}
            >
              <i className="demo-pli-pen-5 fs-5 me-2"></i>
              <span className="nav-label ms-1">Policies</span>
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink
              to="/claims"
              className={({ isActive }) =>
                isActive
                  ? "mininav-toggle nav-link active"
                  : "mininav-toggle nav-link collapsed"
              }
            >
              <i className="demo-pli-speech-bubble-5 fs-5 me-2"></i>
              <span className="nav-label ms-1">Claims</span>
            </NavLink>
          </li>
          {/* <!-- END : Link with submenu --> */}

          {/* <!-- Link with submenu --> */}
          <li className="nav-item has-sub">
            <NavLink
              to="/companies"
              className={({ isActive }) =>
                isActive
                  ? "mininav-toggle nav-link active"
                  : "mininav-toggle nav-link collapsed"
              }
              onClick={toggleSubMenu}
            >
              <i className="demo-pli-receipt-4 fs-5 me-2"></i>
              <span className="nav-label ms-1">Companies</span>
            </NavLink>

            {/* <!-- Tables submenu list --> */}
            <ul className="mininav-content nav collapse">
              <li className="nav-item">
                <NavLink to="/companies/add" className="nav-link">
                  Add New
                </NavLink>
              </li>
            </ul>
            {/* <!-- END : Tables submenu list --> */}
          </li>
          {/* <!-- END : Link with submenu --> */}
        </ul>
      </div>

      <div className="mainnav__categoriy py-3">
        <h6 className="mainnav__caption mt-0 px-3 fw-bold">Settings</h6>
        <ul className="mainnav__menu nav flex-column">
          <li className="nav-item has-sub">
            <NavLink
              to="#"
              className={({ isActive }) =>
                isActive
                  ? "mininav-toggle nav-link"
                  : "mininav-toggle nav-link collapsed"
              }
              onClick={toggleSubMenu}
            >
              <i className="demo-pli-computer-secure fs-5 me-2"></i>
              <span className="nav-label ms-1">Configurations</span>
            </NavLink>
            <ul className="mininav-content nav collapse">
              <li className="nav-item">
                <Link to="/companies/types" className="nav-link">
                  Company Type
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/policy-types" className="nav-link">
                  Policy Type
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/policy-requirements" className="nav-link">
                  Policy Requirements
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/users" className="nav-link">
                  Users
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/products" className="nav-link">
                  Products
                </Link>
              </li>
            </ul>
          </li>

          <li className="nav-item has-sub">
            <NavLink
              to="#"
              className={({ isActive }) =>
                isActive
                  ? "mininav-toggle nav-link"
                  : "mininav-toggle nav-link collapsed"
              }
              onClick={toggleSubMenu}
            >
              <i className="demo-pli-mail fs-5 me-2"></i>
              <span className="nav-label ms-1">Notification Center</span>
            </NavLink>
            <ul className="mininav-content nav collapse">
              <li className="nav-item">
                <Link to="/notifications/sms-messaging" className="nav-link">
                  SMS Messaging
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/notifications/email-messaging" className="nav-link">
                  Email Messaging
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/notifications/settings" className="nav-link">
                  Settings
                </Link>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </>
  );
};

export default AdminNav;
